import { AvatarTypes } from './types';

import './avatar.css';

export default function Avatar({
  size = 'small',
  imageUrl,
  alt = 'avatar image',
}: AvatarTypes): React.JSX.Element {
  return (
    <div className={`avatar avatar-${size}`}>
      <img src={imageUrl} alt={alt} />
    </div>
  );
}
